<template>
  <div class="flex flex-col">
    <header class="relative px-2 py-1 bg-blacko-70 text-white">
      <div
        class="absolute top-0 right-0 font-thin pr-2 pt-1 cursor-pointer"
        @click="$emit('close')"
      >
        <font-awesome-icon icon="times"></font-awesome-icon>
      </div>
      <slot name="header"></slot>
    </header>
    <div class="flex flex-1 flex-col justify-between items-stretch h-full">
      <main class="flex-1 flex flex-col items-stretch border-gray-100">
        <slot name="main"></slot>
      </main>
      <footer class="pb-2" v-if="showFooter">
        <slot name="footer"></slot>
      </footer>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    showFooter: {
      type: Boolean,
      default: true,
    },
  },
  components: {},
  mixins: [],
  data: function () {
    return {};
  },
  methods: {},
  computed: {},
  mounted() {},
};
</script>

<style></style>
